import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBTable, MDBTableBody, MDBTableHead, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter,MDBBox, MDBJumbotron } from 'mdbreact';
import { Form, Input, Button, Checkbox } from 'antd';
import Login from './Login';
import Axios from 'axios'
import { URL } from '../api';
import ff from '../img/9bHjJNbY.jpg';
import dsd from '../img/bn.jpg'
import dsd2 from '../img/Untitledhhhh.jpg'
export default class Homemain extends Component {
    
    //    state = {
    //       Username: "",
    //       Password: "",
    //       loading: true,
    //       login_error: true,
    //       login_error2: true,
    //       login_error3: true,
    //     }

        constructor(props) {
            super(props);
            this.state = {
                value: '',
                Psaaword:'',
                modal: false,
            };
            this.handleChange = this.handleChange.bind(this);
            this.handleChange2 = this.handleChange2.bind(this);
            this.handleSubmit = this.handleSubmit.bind(this);
            this.toggle = this.toggle.bind(this);
          }


          toggle = () => {
            this.setState({
              modal: !this.state.modal
            });
          }
        
          handleChange(event) {    this.setState({value: event.target.value});  }
          handleChange2(event) {    this.setState({Psaaword: event.target.value});  }



      
          handleSubmit(event) {
            // alert('A name was submitted: ' + this.state.value);
             event.preventDefault();
            const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
         datafrm.append("Username", this.state.value);
         datafrm.append("Psaaword", this.state.Psaaword);

         Axios
         // .post("https://admission.kpru.ac.th/refund/api/getdata/getuseradmin", { Username: this.form.name, Password: this.form.pass })
          // .post("https://conference.kpru.ac.th/PHPAPI/select.php",datafrm)
           .post("https://edu.kpru.ac.th/conference/PHPAPI/select.php",datafrm)
           .then(res => {
             console.log("response: ", res)
             if (res.data.length !== 0) {
              // this.showitem = true;
               console.log(res)
               console.log(res.data.length)

               if (res.data[0].register_status === "1") {


                return this.setState({
                  loading: true,
                  // token_exp: +decodedEXP + "000"  //เก็บค่าหมดอายุของ token มาไว้ในตัวแปร
                }),
                  //   localStorage.setItem('tokenExp', decodedEXP + "000"),
                  localStorage.setItem('nameuser', res.data[0].register_nameth + ' ' + res.data[0].register_lnameth),
                  localStorage.setItem('admin_type', res.data[0].register_status),
                  localStorage.setItem('iduser', res.data[0].id),

                  //   localStorage.setItem('profile', JSON.stringify(res.data[0]))
                 // window.location.href = ''
              //   window.location.href = 'https://conference.kpru.ac.th/adminconference-sd/Homeuser'
                    window.location.href = 'https://edu.kpru.ac.th/conference/Homeuser'
                 // this.props.history.replace({ pathname: 'Homeuser' })
              }
              else if (res.data[0].register_status === "2") {
                return this.setState({
                  login_error3: true,
                  // picuser: data.picture,
                }),
    
                  localStorage.setItem('nameuser', res.data[0].register_nameth + ' ' + res.data[0].register_lnameth),
                  localStorage.setItem('admin_type', res.data[0].register_status),
    
                  // localStorage.setItem('picuser', data[0].picture);


                   window.location.href = 'https://edu.kpru.ac.th/conference/superadmin'
                 // window.location.href = '/superadmin'


                //  this.props.history.replace({ pathname: '/Reportbanner' })
              }
              else if (res.data[0].register_status === "3") {
                return this.setState({
                  login_error3: true,
                  // picuser: data.picture,
                }),
    
                  localStorage.setItem('nameuser', res.data[0].register_nameth + ' ' + res.data[0].register_lnameth),
                  localStorage.setItem('admin_type', res.data[0].register_status),
                  localStorage.setItem('expert_id', res.data[0].id),
    
                  // localStorage.setItem('picuser', data[0].picture);

                  window.location.href = 'https://edu.kpru.ac.th/conference/expert'
                 // window.location.href = '/expert'


                //  this.props.history.replace({ pathname: '/Reportbanner' })
              }  else if (res.data[0].register_status === "4") {
                return this.setState({
                  login_error3: true,
                  // picuser: data.picture,
                }),
    
                  localStorage.setItem('nameuser', res.data[0].register_nameth + ' ' + res.data[0].register_lnameth),
                  localStorage.setItem('admin_type', res.data[0].register_status),
                  localStorage.setItem('admin_faculty', res.data[0].register_faculty),
    
                  // localStorage.setItem('picuser', data[0].picture);

                  window.location.href = 'https://edu.kpru.ac.th/conference/adminfaculty'
                 // window.location.href = '/adminfaculty'

                //  this.props.history.replace({ pathname: '/Reportbanner' })
              }else if (res.data[0].register_status === "5") {
                return this.setState({
                  login_error3: true,
                  // picuser: data.picture,
                }),
    
                  localStorage.setItem('nameuser', res.data[0].register_nameth + ' ' + res.data[0].register_lnameth),
                  localStorage.setItem('admin_type', res.data[0].register_status),
                  localStorage.setItem('expert_id', res.data[0].id),
    
                  // localStorage.setItem('picuser', data[0].picture);

                  window.location.href = 'https://edu.kpru.ac.th/conference/expertbn'
                 // window.location.href = '/adminfaculty'

                //  this.props.history.replace({ pathname: '/Reportbanner' })
              }

             }else{
              this.setState({
                modal: true
               
            })
              // window.location.href = '/'
              // window.location.href = '/'
             }
             // do something about response
           })

          }


    update = () => {
        this.setState({
            name: "",
            lname: ""
        })
    }
    

    render() {
        return (
            <div>
                <MDBContainer >
                <div className='mt-1'>
                   {/* <img src="https://conference.kpru.ac.th/Research/views/login/headercf.png" className="rounded  d-block w-200" alt="aligment"  /> */}
                    
                </div>
                <div className='mt-1'>
                 <img src={dsd} className="rounded  d-block "alt="aligment" />
              </div>
                 <MDBJumbotron>

             {/* <div className='mt-1'>
                 <img src={dsd2} className="rounded  d-block "alt="aligment" />
              </div> */}
              {/* <br/> */}
              <h5>ดาวน์โหลดไฟล์ รายงานสืบเนื่องจากการประชุมวิชาการระดับชาติ "ครุศาสตร์ศึกษา" ครั้งที่ 8</h5>
                    
                      <MDBTable>
                    <MDBTableHead>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อเอกสาร</th>
                        <th>Download</th>
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                       <tr>
                        <td>1</td>
                        <td>ฉบับเต็ม-รายงานสืบเนื่องจากการประชุมวิชาการฯ</td>
                        <td> <MDBBtn outline size='sm'  href="https://edu.kpru.ac.th/conference/PHPAPI/procedingfull.pdf"
                                target="_blank">ดาวน์โหลด</MDBBtn></td>
                        </tr>

                        <tr>
                        <td>2</td>
                        <td>สาขาวิชาคณิตศาสตร์</td>
                        <td> <MDBBtn outline size='sm'  href="https://edu.kpru.ac.th/conference/PHPAPI/proceding1.pdf"
                                target="_blank">ดาวน์โหลด</MDBBtn></td>
                        </tr>

                         <tr>
                        <td>3</td>
                        <td>สาขาวิชาวิทยาศาสตร์ทั่วไป / ฟิสิกส์ / เคมี / ชีวิวิทยา </td>
                        <td> <MDBBtn outline size='sm'  href="https://edu.kpru.ac.th/conference/PHPAPI/proceding2.pdf"
                                target="_blank">ดาวน์โหลด</MDBBtn></td>
                        </tr>

                        <tr>
                        <td>4</td>
                        <td>สาขาวิชาภาษาอังกฤษ</td>
                        <td> <MDBBtn outline size='sm'  href="https://edu.kpru.ac.th/conference/PHPAPI/proceding3.pdf"
                                target="_blank">ดาวน์โหลด</MDBBtn></td>
                        </tr>

                        <tr>
                        <td>5</td>
                        <td>สาขาวิชาภาษาไทย</td>
                        <td> <MDBBtn outline size='sm'  href="https://edu.kpru.ac.th/conference/PHPAPI/proceding4.pdf"
                                target="_blank">ดาวน์โหลด</MDBBtn></td>
                        </tr>

                         <tr>
                        <td>6</td>
                        <td>สาขาวิชาภาษาจีน / ภาษาเกาหลี</td>
                        <td> <MDBBtn outline size='sm'  href="https://edu.kpru.ac.th/conference/PHPAPI/proceding5.pdf"
                                target="_blank">ดาวน์โหลด</MDBBtn></td>
                        </tr>

                         <tr>
                        <td>7</td>
                        <td>สาขาวิชาการศึกษาปฐมวัย</td>
                        <td> <MDBBtn outline size='sm'  href="https://edu.kpru.ac.th/conference/PHPAPI/proceding6.pdf"
                                target="_blank">ดาวน์โหลด</MDBBtn></td>
                        </tr>

                         <tr>
                        <td>8</td>
                        <td>สาขาวิชาพลศึกษา / สุขศึกษา</td>
                        <td> <MDBBtn outline size='sm'  href="https://edu.kpru.ac.th/conference/PHPAPI/proceding7.pdf"
                                target="_blank">ดาวน์โหลด</MDBBtn></td>
                        </tr>

                         <tr>
                        <td>9</td>
                        <td>สาขาวิชาคอมพิวเตอร์ศึกษา/นวัตกรรมและเทคโนโลยีทางการศึกษา</td>
                        <td> <MDBBtn outline size='sm'  href="https://edu.kpru.ac.th/conference/PHPAPI/proceding8.pdf"
                                target="_blank">ดาวน์โหลด</MDBBtn></td>
                        </tr>

                         <tr>
                        <td>10</td>
                        <td>สาขาวิชาสังคมศึกษา / เกษตร / คหกรรมศาสตร์</td>
                        <td> <MDBBtn outline size='sm'  href="https://edu.kpru.ac.th/conference/PHPAPI/proceding9.pdf"
                                target="_blank">ดาวน์โหลด</MDBBtn></td>
                        </tr>

                         <tr>
                        <td>11</td>
                        <td>สาขาวิชาการประถมศึกษา</td>
                        <td> <MDBBtn outline size='sm'  href="https://edu.kpru.ac.th/conference/PHPAPI/proceding10.pdf"
                                target="_blank">ดาวน์โหลด</MDBBtn></td>
                        </tr>

                         <tr>
                        <td>12</td>
                        <td>สาขาวิชาการศึกษาพิเศษ</td>
                        <td> <MDBBtn outline size='sm'  href="https://edu.kpru.ac.th/conference/PHPAPI/proceding11.pdf"
                                target="_blank">ดาวน์โหลด</MDBBtn></td>
                        </tr>

                         <tr>
                        <td>13</td>
                        <td>สาขาวิชานาฏศิลป์/ดนตรี/ ศิลปะ/ อุตสาหกรรมศิลป์</td>
                        <td> <MDBBtn outline size='sm'  href="https://edu.kpru.ac.th/conference/PHPAPI/proceding12.pdf"
                                target="_blank">ดาวน์โหลด</MDBBtn></td>
                        </tr>

                         <tr>
                        <td>14</td>
                        <td>สาขาวิชาหลักสูตรและการสอน /การบริหารการศึกษา</td>
                        <td> <MDBBtn outline size='sm'  href="https://edu.kpru.ac.th/conference/PHPAPI/proceding13.pdf"
                                target="_blank">ดาวน์โหลด</MDBBtn></td>
                        </tr>

                         <tr>
                        <td>15</td>
                        <td>สาขาวิชาจิตวิทยาการศึกษา / วิจัยและประเมินผลทางการศึกษา / ครูรักษ์ถิ่น</td>
                        <td> <MDBBtn outline size='sm'  href="https://edu.kpru.ac.th/conference/PHPAPI/proceding14.pdf"
                                target="_blank">ดาวน์โหลด</MDBBtn></td>
                        </tr>

                        {/* <tr>
                        <td>1</td>
                        <td>คู่มือการใช้งานระบบNCE CONFERENCE - สำหรับผู้แต่ง</td>
                        <td> <MDBBtn outline size='sm'  href="https://edu.kpru.ac.th/conference/PHPAPI/NCE1.pdf"
                                target="_blank">ดาวน์โหลด</MDBBtn></td>
                        </tr>

                        <tr>
                        <td>2</td>
                        <td>คำแนะนำในการส่งบทความวิจัย-วิชาการ</td>
                        <td> <MDBBtn outline size='sm'  href="https://edu.kpru.ac.th/conference/PHPAPI/NCE2.pdf"
                                target="_blank">ดาวน์โหลด</MDBBtn></td>
                        </tr>

                         <tr>
                        <td>3</td>
                        <td>รูปแบบการเขียนบทความ-วิจัย</td>
                        <td> <MDBBtn outline size='sm'  href="https://edu.kpru.ac.th/conference/PHPAPI/NCE3.pdf"
                                target="_blank">ดาวน์โหลด</MDBBtn></td>
                        </tr>

                        <tr>
                        <td>4</td>
                        <td>รูปแบบการเขียนบทความ-วิชาการ</td>
                        <td> <MDBBtn outline size='sm'  href="https://edu.kpru.ac.th/conference/PHPAPI/NCE4.pdf"
                                target="_blank">ดาวน์โหลด</MDBBtn></td>
                        </tr>

                        <tr>
                        <td>5</td>
                        <td>แบบรับรองบทความวิจัย-วิชาการ</td>
                        <td> <MDBBtn outline size='sm'  href="https://edu.kpru.ac.th/conference/PHPAPI/NCE5.pdf"
                                target="_blank">ดาวน์โหลด</MDBBtn></td>
                        </tr>

                         <tr>
                        <td>6</td>
                        <td>คำแนะนำสำหรับผู้นำเสนอผลงานวิจัยแบบโปสเตอร์และแบบบรรยาย</td>
                        <td> <MDBBtn outline size='sm'  href="https://edu.kpru.ac.th/conference/PHPAPI/advice.pdf"
                                target="_blank">ดาวน์โหลด</MDBBtn></td>
                        </tr>

                         <tr>
                        <td>7</td>
                        <td>Template Poster Presentation ไฟล์นามสกุล.pptx</td>
                        <td> <MDBBtn outline size='sm'  href="https://edu.kpru.ac.th/conference/PHPAPI/Template Poster Presentation.pptx"
                                target="_blank">ดาวน์โหลด</MDBBtn></td>
                        </tr>

                         <tr>
                        <td>8</td>
                        <td>Template Poster Presentation ไฟล์ภาพนามสกุล.JPG</td>
                        <td> <MDBBtn outline size='sm'  href="https://edu.kpru.ac.th/conference/PHPAPI/poster.jpg"
                                target="_blank">ดาวน์โหลด</MDBBtn></td>
                        </tr>

                         <tr>
                        <td>9</td>
                        <td>Template Oral Presentation ไฟล์นามสกุล.pptx</td>
                        <td> <MDBBtn outline size='sm'  href="https://edu.kpru.ac.th/conference/PHPAPI/Template Oral Presentation.pptx"
                                target="_blank">ดาวน์โหลด</MDBBtn></td>
                        </tr>

                         <tr>
                        <td>10</td>
                        <td>ตารางการนำเสนอแบบบรรยาย (Oral Presentation)</td>
                        <td> <MDBBtn outline size='sm'  href="https://edu.kpru.ac.th/conference/PHPAPI/OralPresentation.pdf"
                                target="_blank">ดาวน์โหลด</MDBBtn></td>
                        </tr>

                         <tr>
                        <td>11</td>
                        <td>ตารางการนำเสนอแบบโปสเตอร์ (Poster Presentation)</td>
                        <td> <MDBBtn outline size='sm'  href="https://edu.kpru.ac.th/conference/PHPAPI/PosterPresentation.pdf"
                                target="_blank">ดาวน์โหลด</MDBBtn></td>
                        </tr> */}


                     
                    </MDBTableBody>
           </MDBTable>
                   
                  
                 
  </MDBJumbotron>
                   
                   
                    </MDBContainer>
                   
            </div>
        )
    }
}
